import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgVideocamera = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.5 7.02a3.52 3.52 0 1 1 7.038 0 3.52 3.52 0 0 1-7.038 0M7.02 2a5.02 5.02 0 1 0 0 10.038A5.02 5.02 0 0 0 7.02 2m7.865 6.442a2.096 2.096 0 1 1 4.192 0 2.096 2.096 0 0 1-4.192 0m2.096-3.596a3.596 3.596 0 1 0 0 7.192 3.596 3.596 0 0 0 0-7.192m-8.538 10.75a.673.673 0 0 0-.673.673v3.558c0 .372.3.673.673.673h7.827a.673.673 0 0 0 .673-.673v-3.558a.673.673 0 0 0-.674-.673zm-2.173.673c0-1.2.972-2.173 2.173-2.173h7.827c1.2 0 2.173.973 2.173 2.173v3.558c0 1.2-.973 2.173-2.174 2.173H8.444c-1.2 0-2.173-.973-2.173-2.173zm15.73 0a.75.75 0 0 0-1.5 0v3.558a.75.75 0 0 0 1.5 0z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgVideocamera;
